var render = function render(){var _vm=this,_c=_vm._self._c;return _c('patient-pie-analysis',{attrs:{"title":"Messenger會員語系圓餅圖","data":_vm.sourceData}})
}
var staticRenderFns = []

export { render, staticRenderFns }